import PillFilters, { PillFiltersProps, ScrollerItemData } from './PillFilters';

export type { PillFiltersProps, ScrollerItemData };
export default PillFilters;
